import {
    FETCH_USER_SOCIAL_PROFILE_FETCHING,
    FETCH_USER_SOCIAL_PROFILE_SUCCESS,
    FETCH_USER_SOCIAL_PROFILE_FAIL,
    UPDATE_USER_SOCIAL_PROFILE_UPDATING,
    UPDATE_USER_SOCIAL_PROFILE_SUCCESS,
    UPDATE_USER_SOCIAL_PROFILE_FAIL,
    UPDATE_REDUX_USER_PUBLIC_PROFILE_IMAGE
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    userSocialProfiles: {},
    userRoles: [],
    userSocialProfilesFetching: false,
    userSocialProfilesFetchSuccess: false,
    userSocialProfilesFetchFail: false,
    userSocialProfilesUpdating: false,
    userSocialProfilesUpdateFail: false
};

// ======= Fetching Handlers =======
const userSocialProfilesFetching = (state) => {
    return {
        ...state,
        userSocialProfilesFetching: true,
        userSocialProfilesFetchSuccess: false,
        userSocialProfilesFetchFail: false
    };
};

const userSocialProfilesFetchFinished = (success) => (state, { profile, displayName }) => {
    return {
        ...state,
        userSocialProfiles: success
            ? {
                  ...state.userSocialProfiles,
                  [displayName]: profile
              }
            : state.userSocialProfiles,
        // Storing the roles separately so they can be accessed without pulling in all of the userSocialProfile
        userRoles: success
            ? {
                  ...state.userRoles,
                  [displayName]: profile.userRoles
              }
            : state.userRoles,
        userSocialProfilesFetching: false,
        userSocialProfilesFetchSuccess: success,
        userSocialProfilesFetchFail: !success
    };
};

// ======= Updating Handlers =======
const updateUserSocialProfileUpdating = (state) => {
    return {
        ...state,
        userSocialProfilesUpdating: true,
        userSocialProfilesUpdateFail: false
    };
};

const updateUserSocialProfileUpdateSuccess = (state, { profile, displayName }) => {
    return {
        ...state,
        userSocialProfiles: {
            ...state.userSocialProfiles,
            [displayName]: profile
        },
        userSocialProfilesUpdating: false,
        userSocialProfilesUpdateFail: false
    };
};

const updateUserSocialProfileUpdateFail = (state) => {
    return {
        ...state,
        userSocialProfilesUpdating: false,
        userSocialProfilesUpdateFail: true
    };
};

const updateReduxUserPublicProfileImages = (state, action) => {
    const { displayName, imageUrls } = action;

    if (!state.userSocialProfiles[displayName]) {
        return state;
    }
    return {
        ...state,
        userSocialProfiles: {
            ...state.userSocialProfiles,
            [displayName]: {
                ...state.userSocialProfiles[displayName],
                profileImageUrlLarge: imageUrls.profileImageUrlLarge,
                profileImageUrlMedium: imageUrls.profileImageUrlMedium,
                profileImageUrlSmall: imageUrls.profileImageUrlSmall
            }
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_USER_SOCIAL_PROFILE_FETCHING]: userSocialProfilesFetching,
    [FETCH_USER_SOCIAL_PROFILE_SUCCESS]: userSocialProfilesFetchFinished(true),
    [FETCH_USER_SOCIAL_PROFILE_FAIL]: userSocialProfilesFetchFinished(false),
    [UPDATE_USER_SOCIAL_PROFILE_UPDATING]: updateUserSocialProfileUpdating,
    [UPDATE_USER_SOCIAL_PROFILE_SUCCESS]: updateUserSocialProfileUpdateSuccess,
    [UPDATE_USER_SOCIAL_PROFILE_FAIL]: updateUserSocialProfileUpdateFail,
    [UPDATE_REDUX_USER_PUBLIC_PROFILE_IMAGE]: updateReduxUserPublicProfileImages
};

// ======= Default Action =======
export default function userSocialProfile(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getUserSocialProfile = (state, displayName) => {
    return state.userSocialProfile.userSocialProfiles[displayName];
};

export const isUserSocialProfileFetching = (state) => {
    return state.userSocialProfile.userSocialProfilesFetching;
};

export const didUserSocialProfileFetchFail = (state) => {
    return state.userSocialProfile.userSocialProfilesFetchFail;
};

export const isUserSocialProfileUpdating = (state) => {
    return state.userSocialProfile.userSocialProfilesUpdating;
};

export const didUserSocialProfileUpdateFail = (state) => {
    return state.userSocialProfile.userSocialProfilesUpdateFail;
};

export const getUserRoles = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName];
};

export const hasRole = (state, displayName, role) => {
    return state.userSocialProfile.userRoles[displayName].includes(role);
};

export const isWellnessUser = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName].includes('ROLE_WELLNESS_USER');
};

export const isFitnessUser = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName].includes('ROLE_FITNESS_USER');
};

export const isDiveUser = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName].includes('ROLE_DIVE_USER');
};

export const isRaceEventProvider = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName].includes('ROLE_RACE_EVENT_PROVIDER');
};

// This is the old ProdBeta, now called Alpha
export const isAlphaUser = (state, displayName) => {
    return state.userSocialProfile.userRoles[displayName]?.includes('ROLE_CONNECTBETAUSER');
};
